// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-project[data-v-f6b31706] {
  height: 338px;
}
.match-project .table[data-v-f6b31706] {
  margin-top: 10px;
  height: calc(100% - 38px);
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/DataAnalysis/MatchProject.vue","webpack://./MatchProject.vue"],"names":[],"mappings":"AACA;EACE,aAAA;ACAF;ADDA;EAGI,gBAAA;EACA,yBAAA;ACCJ","sourcesContent":["\n.match-project {\n  height: 338px;\n  .table {\n    margin-top: 10px;\n    height: calc(100% - 38px);\n  }\n}\n",".match-project {\n  height: 338px;\n}\n.match-project .table {\n  margin-top: 10px;\n  height: calc(100% - 38px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
